import { RequestService } from '../../../../../common/services/RequestService';
import { TRANSFERS_GET } from '../../constants';

export const getTransfersRequest = payload => {
  return RequestService.get(TRANSFERS_GET);
};
